<template>
  <v-autocomplete :value="innerValue" v-bind="attrs" v-on="listeners" :search-input.sync="search">
    <template v-slot:item="{ item }">
      <v-list-item-icon class="mr-3">
        <v-icon>mdi-map-marker-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>
          <span v-text="item.name" />
          <span v-text="'•'" class="mx-2" />
          <span v-text="getDesc(item)" class="text--secondary font-weight-regular" />
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
// import { ValidationProvider } from 'vee-validate'

import { searchPlace } from '@/services/search-api.service'

const mapEntry = (entry) => {
  const { sgla_pse, des_com, sgla_prv, des_pse, des_prv } = entry
  let name = ''
  let full_name = ''

  if (sgla_pse === 'IT') {
    name = `${des_com}`
    full_name = `${des_com} (${sgla_prv})`
  } else if (des_prv) {
    name = `${des_prv}`
    full_name = `${des_prv} (${des_pse})`
  } else {
    name = `${des_pse}`
    full_name = `${des_pse}`
  }

  return {
    id: entry.id,
    name,
    full_name,
    province: {
      id: entry.sgla_prv,
      name: entry.des_prv,
      neighbors: entry.sgle_prv_lim,
    },
    country: {
      id: entry.sgla_pse,
      name: entry.des_pse,
    },
  }
}

export default {
  name: 'PlaceSearchField',
  inheritAttrs: false,
  components: {},
  props: {
    value: {
      type: [Object, String],
      default: null,
    },
    locale: {
      type: String,
      default: '',
    },
    converter: {
      type: Function,
      default: mapEntry,
    },
  },
  data: () => ({
    innerValue: null,
    entries: [],
    isLoading: false,
    search: null,
  }),
  computed: {
    attrs() {
      return {
        noDataText: 'Nessun risultato',
        itemValue: 'id',
        itemText: 'full_name',
        ...this.$attrs,
        items: this.entries,
        returnObject: true,
        loading: this.isLoading,
      }
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.handleInput,
      }
    },
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.innerValue = null
        this.items = []
      } else {
        this.innerValue = JSON.parse(JSON.stringify(newVal))
        this.entries = newVal ? [this.innerValue] : []
      }
    },

    search(val) {
      if (!val) return
      if (val.length < 2) return
      if (this.isLoading) return

      this.isLoading = true

      searchPlace(val, this.locale)
        .then(({ data: results }) => {
          this.entries = results.map(mapEntry)
        })
        .catch((err) => {
          console.error(err)
        })
        .finally(() => (this.isLoading = false))
    },
  },
  created() {
    if (!this.value) {
      this.innerValue = null
      this.items = []
    } else {
      this.innerValue = JSON.parse(JSON.stringify(this.value))
      this.entries = this.value ? [this.innerValue] : []
    }
  },
  methods: {
    handleInput(value) {
      this.innerValue = value
      this.$emit('input', value)
    },
    getDesc(item) {
      const { country, name, province } = item

      if (country.id === 'IT') return name === province.name ? 'Comune' : province.name
      if (province.name) return country.name
      return `Stato estero`
    },
  },
}
</script>

<style lang="scss" scoped></style>
